import React from 'react';
import { formatDate, numberToWords } from './utils.js';
import './InvoicePreview.css';

const InvoicePreview = ({ data }) => {
  // Calculate totals
  const subtotal = data.items.reduce((sum, item) => sum + (item.qty * item.rate), 0);
  const cgst = subtotal * (data.taxes.cgst / 100);
  const sgst = subtotal * (data.taxes.sgst / 100);
  const igst = subtotal * (data.taxes.igst / 100);
  const total = subtotal + cgst + sgst + igst;

  const renderImage = (base64Image) => {
    return base64Image ? (
      <img src={base64Image} alt="Seller Logo" className="seller-logo" />
    ) : null;
  };

  return (
    <div className="invoice-container">
      <div id="invoice-preview">
        <div className="header-title">TAX INVOICE</div>

        <table className="seller-info">
          <tbody>
            <tr>
              <td colSpan="4" className="seller-details">
                <p className="seller-name">{data.seller.name}</p>
                <address className="seller-address">
                  {data.seller.address}
                </address>
                <div className="seller-contact">
                  <span>Mob: {data.seller.mobile}</span>
                  <span>Email: {data.seller.email}</span>
                </div>
              </td>
              <td className="logo-cell">
                {renderImage(data.seller.image)}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="invoice-meta">
          <tbody>
            <tr>
              <th>Invoice No.</th>
              <td>{data.invoice.number}</td>
            </tr>
            <tr>
              <th>Invoice Date</th>
              <td>{formatDate(data.invoice.date)}</td>
            </tr>
          </tbody>
        </table>

        <table className="parties-info">
          <tbody>
            <tr>
              <th colSpan="4">Seller: Name & Address</th>
              <th colSpan="4">Buyer: Name & Address</th>
            </tr>
            <tr>
              <td colSpan="4" className="party-details">
                <p className="party-name">{data.seller.name}</p>
                <address className="party-address">{data.seller.address}</address>
              </td>
              <td colSpan="4" className="party-details">
                <p className="party-name">{data.buyer.name}</p>
                <address className="party-address">{data.buyer.address}</address>
              </td>
            </tr>
            <tr className="party-tax-info">
              <th>Pan No</th>
              <td>{data.seller.pan}</td>
              <th>GST No.</th>
              <td>{data.seller.gst}</td>
              <th>Pan No</th>
              <td>{data.buyer.pan}</td>
              <th>GST No.</th>
              <td>{data.buyer.gst}</td>
            </tr>
          </tbody>
        </table>

        <div lassName="invoice-items-footer">
          <div className="items-table-container">
            <table className="invoice-items">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Description</th>
                  <th>HSN Code</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                  <th>Rate/unit INR (Rs.)</th>
                  <th>Amount INR (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.description}</td>
                    <td>{item.hsn}</td>
                    <td>{item.qty}</td>
                    <td>{item.unit}</td>
                    <td className="text-right">{item.rate.toFixed(2)}</td>
                    <td className="text-right">{(item.qty * item.rate).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="signature-space">


          </div>
          <div className="invoice-footer-container">
            <table className="invoice-footer-box">
              <tbody>
                <tr>
                  <td colSpan="6" className="amount-words text-right">
                    <strong>{numberToWords(total)}</strong>
                  </td>
                  <td colSpan="2">Total Amount (Rs. in Words)</td>
                </tr>
                <tr>
                  <td>Packing & Forwarding</td>
                  <td>0.00</td>
                  <td>Freight</td>
                  <td>0.00</td>
                  <td>Insurance</td>
                  <td>0.00</td>
                  <td className="text-right bold">Sub Total:</td>
                  <td className="text-right">{subtotal.toFixed(2)}</td>
                </tr>
                {cgst > 0 && (
                  <tr>
                    <td colSpan="6" className="text-right bold">
                      CGST @ {data.taxes.cgst}%:
                    </td>
                    <td colSpan="2" className="text-right">{cgst.toFixed(2)}</td>
                  </tr>
                )}
                {sgst > 0 && (
                  <tr>
                    <td colSpan="6" className="text-right bold">
                      SGST @ {data.taxes.sgst}%:
                    </td>
                    <td colSpan="2" className="text-right">{sgst.toFixed(2)}</td>
                  </tr>
                )}
                {igst > 0 && (
                  <tr>
                    <td colSpan="6" className="text-right bold">
                      IGST @ {data.taxes.igst}%:
                    </td>
                    <td colSpan="2" className="text-right">{igst.toFixed(2)}</td>
                  </tr>
                )}
                <tr className="grand-total">
                  <td colSpan="6" className="text-right bold">
                    Total Invoice Amount:
                  </td>
                  <td colSpan="2" className="text-right bold">{total.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>

            <div className="invoice-footer-name">
              <p>Certified that the particulars given above are true and correct.</p>
              <p>This is computer generated invoice and does not require signature.</p>
              <p className="text-center thank-you">Thank You for Your Business!</p>
              <p className="text-center company-name">{data.companyName}</p>
            </div>
          </div>
        </div>



      </div>
    </div>
  );
};

export default InvoicePreview;